// todo
// enum
// filter
// $request schema
// 开发模式无需 schema 提高性能
export function dataSchemaToTypes(schema) {
  const typeString = getObjectTypeString(schema, true);
  return typeString;
}
// eslint-disable-next-line complexity
export function getObjectTypeString(schema, root = false, isMethod = false) {
  const {
    id,
    title
  } = schema;
  const typeString = getPropertyTypeString(id, getTypeString(schema), root ? undefined : title, isMethod);
  if (root) {
    return `${title ? `
  /**
  * ${title || ''}
  */` : ''}
  var ${typeString.trim()}
  `;
  }
  return typeString;
}
// eslint-disable-next-line complexity
export function getTypeString(schema) {
  const {
    type,
    fields = [],
    items,
    methods = []
  } = schema;
  switch (type) {
    case 'string':
    case 'number':
    case 'boolean':
    case 'any':
    case 'null':
      return getPrimitiveType(type, schema);
    case 'integer':
      return getPrimitiveType('number', schema);
    case 'object':
      return ['{', ...fields.map(f => getObjectTypeString(f)), ...methods.map(m => getMethodType(m)), '}'].join('  \n');
    case 'array':
      if (!items) {
        return 'Array<any>';
      }
      return ['Array<', getTypeString(items), '>'].join('\n');
    default:
      return 'any';
  }
}
function getPrimitiveType(type, schema) {
  let types = [type];
  // @ts-ignore
  if (schema.jsonStringType && type === 'string') {
    // @ts-ignore
    const jsonType = getTypeString(schema.jsonStringType);
    types.push(jsonType);
  }
  const enumList = schema.enum;
  if (Array.isArray(enumList) && enumList.length) {
    types = enumList.map(item => {
      try {
        const typeString = JSON.stringify(item.value);
        return typeString;
      } catch (error) {
        console.error(error);
        return null;
      }
    }).filter(Boolean);
  }
  return types.join(' | ');
}
function getPropertyTypeString(id, type, title, isMethod) {
  return `${title ? `
  /**
  * ${title || ''}
  */` : ''}
  ${getId(id, !isMethod)}:${type}`;
}
function getId(id, valid = true) {
  if (!valid || isValidVariableName(id)) {
    return `${id || 'unknown'}`;
  }
  return `['${String(id)}']`;
}
function getMethodType(method) {
  var _method$arguments;
  const args = ((_method$arguments = method.arguments) === null || _method$arguments === void 0 ? void 0 : _method$arguments.map(item => getObjectTypeString(item, false, true))) || [];
  // todo isAsync
  const argString = args.join(',');
  const returnType = method.returnValue ? getTypeString(method.returnValue) : 'any';
  const returnTypeString = method.isAsync ? `Promise<${returnType}>` : returnType;
  return `
  /**
   * ${method.title || method.description || ''}
   */
  ${method.id}(${argString}):${returnTypeString}
  `;
}
function isValidVariableName(variableName) {
  const name = String(variableName);
  return /^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(name);
}
//# sourceMappingURL=dataSchemaToTypes.js.map
